/**
 * Stack program amount helpers.
 *
 * `amount_text` is meant to hold a short amount phrase ("Up to $15,000",
 * "Varies by county"). A lot of nonprofit/counseling programs instead carry a
 * full sentence describing the benefit, which used to be rendered in the
 * card's no-wrap right-hand slot and blew out the layout. These helpers split
 * the two cases so long text renders in the card body instead.
 */

const AMOUNT_MAX_LEN = 40;

const AMOUNT_PHRASES =
  /(varies|no fixed amount|amount varies|n\/?a|tbd|case[- ]by[- ]case|not disclosed|free)/i;

/** True when the text looks like a short amount, safe for the compact slot. */
export function isAmountLike(text?: string | null): boolean {
  const t = (text ?? "").trim();
  if (!t) return false;
  if (t.length > AMOUNT_MAX_LEN) return false;
  if (/[.!?]\s/.test(t)) return false; // multi-sentence
  return /\$|\d\s*%|\bpercent\b/i.test(t) || AMOUNT_PHRASES.test(t);
}

/** The long-form benefit description hiding in amount_text, if any. */
export function benefitDescription(text?: string | null): string | null {
  const t = (text ?? "").trim();
  if (!t || isAmountLike(t)) return null;
  return t;
}
